export default [
    {
        path: '/vacancy-settings',
        name: 'vacancy-settings',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Configurações de Ocupação',
            icon: 'mdi-cog',
            breadcrumbs: [
                { text: 'Controle de Vagas', to: '/vacancy-control' },
                { text: 'Configurações', disabled: true }
            ]
        }
    }
]
